import loginModule from '../loginModule.js';

function horizontalLoginForm() {
  return {
    restrict: 'A',
    replace: false,
    templateUrl: 'horizontal-login-form',
    controller: 'loginFormController',
    link: function link(scope, element, attrs) {
      scope.loginParams = {
        redirectToLoginPageOnError: attrs.redirectToLoginPageOnError === 'true',
        redirectToHomePostLogin: attrs.redirectToHomePostLogin === 'true'
      };
    }
  };
}

loginModule.directive('horizontalLoginForm', horizontalLoginForm);

export default horizontalLoginForm;
